import React from "react";

import DW1 from "../../../../assets/images/dwarve1.png";
import DW2 from "../../../../assets/images/dwarve2.png";
import DW3 from "../../../../assets/images/dwarve3.png";

import blue from "../../../../assets/images/blue.png";
import red from "../../../../assets/images/red.png";
import green from "../../../../assets/images/green.png";
import gold from "../../../../assets/images/gold.png";
import silver from "../../../../assets/images/silver.png";
import yellowwave from "../../../../assets/images/yellow-wave.svg";
import yellow1 from "../../../../assets/images/yellow1.svg";
import bluewave from "../../../../assets/images/blue-wave.svg";
import blue2 from "../../../../assets/images/blue2.svg";
import blue1 from "../../../../assets/images/blue1.svg";
import badge from "../../../../assets/images/brandpush-trust-badge.png";
import logo from "../../../../assets/images/logo2-black.png";
import "./beterayal.scss";

const Beterayal = () => {
  const handleRoute = () => {
    window.open(
      "            https://raritysniper.com/nft-drops-calendar",
      "_blank"
    );
  };

  return (
    <>
      <img
        src={blue1}
        alt=""
        style={{ width: "150%", margin: "0% 0% 0% -24%" }}
      />
      <div className="beterayal_container">
        <div className="box">
          <div className="data">
            <div className="title">The Betrayal</div>
            {/* <div className="detail"> NFT, blockchain & cryptos for all  </div> */}
            <div className="dis">
              The Rich Dwarves were a powerful tribe. Set in the mines of Sif
              mountain, they followed their former leaders in search of great
              riches. They were promised wealth, longevity, peace and
              prosperity. But they were betrayed.Their overlords used their
              enthusiasm and resourcefulness against them, stealing the immense
              wealth of their own tribe through evil magic of manipulation,
              coercion, and outright deception. They bribed influential
              charlatans to convince their followers that the wealth was just a
              little deeper into the mine. To dig a little more. To continue to
              trust them in their work.Umdol, Erorg, and Brokk - foul elven
              demons in disguise - disappeared into the wilds without a trace.
              The wrath of the dwarves was one that almost raised Sif Mountain
              to the ground. They had a choice to make - find these deceivers
              and reclaim their wealth - or - rebuild a new kingdom, far from
              the now empty and haunted halls of Sif Mountain. But who would
              lead them? They were fractured, unhinged, frightened, pointing the
              finger at each other as responsible for falling for such a
              ruse.Until a new leader arose.
            </div>

            {/* <Button style={{ color: "#0FFFF7",  border:"2px solid #0FFFF7", backgroundColor: "#000000", width: "200px" }}> Learn more </Button> */}
          </div>

          <div className="img_box">
            <img src={DW1} alt="ERROR" />
          </div>
        </div>

        <div className="box">
          <div className="data">
            <div className="title">The Regrouping</div>
            {/* <div className="detail"> NFT, blockchain & cryptos for all  </div> */}
            <div className="dis">
              @transformermarketing, aka Darren, had a vision for the ruined
              Dwarven tribe. He believed that if the Dwarves harnessed their
              determination, and used their talents to focus on redemption and
              rebirth, rather than wild rage and revenge, the great wealth could
              be restored. He and his followers instruct these lost Dwarves to
              look at this as a chance to reflect and rebuild. The followers
              bellowed at the top of their lungs “Take heed and do not despair!
              We shall restore our once great kingdom and rebuild what was
              destroyed. From this day forth, we shall be known as the Angry
              Dwarves Tribe.” And so the Angry Dwarves faction became a tribe.
              And the tribe began to grow. In the ruins of their mines, the
              abandoned and worthless Dwarves banded together, migrating to a
              new land to rebuild their kingdom and wealth under the banner of
              brotherhood and common need. They found a new mountain, Mount
              Korda, to build a new city on a large island in the Arauglor
              Xunder (Dark Ocean). In a mere 10 days the new Dwarven kingdom of
              Korda Kyth, the city of hammers, was complete. Korda Kyth had
              impenetrable walls so high that even the gods couldn’t see them
              from their thrones. The halls were adorned with gold lined
              pillars, golden thrownes in the homes of common Dwarf-folk, gold
              lettering upon the signs of storefronts, and longboats liveried
              with the golden hammer-crest of Korda Kyth. A Dwarven council had
              been established. The time for redemption had come.
            </div>

            {/* <Button style={{ color: "#0FFFF7",  border:"2px solid #0FFFF7", backgroundColor: "#000000", width: "200px" }}> Learn more </Button> */}
          </div>

          <div className="img_box">
            <img src={DW2} alt="ERROR" />
          </div>
        </div>

        <div className="box">
          <div className="data">
            <div className="title">The Redemption</div>
            {/* <div className="detail"> NFT, blockchain & cryptos for all  </div> */}
            <div className="dis">
              These wrathful Dwarves worked tirelessly to rebuild their city,
              stabilize their economy, and rediscover their culture on top of
              the ashes of wounded pride and stolen wealth. With their tribe
              reunited, they have begun to open their doors to other refugees of
              kingdoms and projects where tyrants have stripped these people of
              their wealth, no matter their colour, creed, race, or gender. The
              Angry Dwarves Tribe welcomes all to Korda Kyth (Hammer City) who
              value community, honesty, transparency, education, and hard work
              in the brave new world of NFTs.
            </div>

            {/* <Button style={{ color: "#0FFFF7",  border:"2px solid #0FFFF7", backgroundColor: "#000000", width: "200px" }}> Learn more </Button> */}
          </div>

          <div className="img_box">
            <img src={DW3} alt="ERROR" />
          </div>
        </div>
        {/* <img
          src={blue2}
          alt=""
          style={{ width: "150%", margin: "0% 0% 0% -24%" }}
        /> */}
        <div
          className="badgediv"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <a
            style={{
              textAlign: "center",
              marginTop: "4pc",
              marginBottom: "4pc",
            }}
            href="https://raritysniper.com/nft-drops-calendar"
            target="_blank"
          >
            <img className="badgeimg" src={logo} onClick={handleRoute}></img>
          </a>
        </div>
      </div>
    </>
  );
};

export default Beterayal;
